"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLE_FIELD_SUCCESS = exports.STYLE_FIELD_WARNING = exports.STYLE_FIELD_ERROR = exports.STYLE_REQUIRED_FIELD_FLEX = exports.STYLE_REQUIRED_RED_STAR = exports.COLOR = void 0;
exports.COLOR = {
    RED: "#FA3232",
    RED_LIGHT: "#f0817f",
    WHITE: "#FFFFFF",
    GRAY: "#F5F5F5",
    GREEN: "#00B300",
    ORANGE: "#FF9100",
};
exports.STYLE_REQUIRED_RED_STAR = {
    color: exports.COLOR.RED,
};
exports.STYLE_REQUIRED_FIELD_FLEX = {
    display: "flex",
};
exports.STYLE_FIELD_ERROR = {
    color: exports.COLOR.WHITE,
    display: "flex",
    backgroundColor: exports.COLOR.RED,
    borderRadius: "5px",
    padding: "7px",
};
exports.STYLE_FIELD_WARNING = {
    color: exports.COLOR.WHITE,
    display: "flex",
    backgroundColor: exports.COLOR.RED,
    borderRadius: "5px",
    padding: "7px",
};
exports.STYLE_FIELD_SUCCESS = {
    color: exports.COLOR.WHITE,
    display: "flex",
    backgroundColor: exports.COLOR.RED,
    borderRadius: "5px",
    padding: "7px",
};
